module.exports = __webpack_public_path__ + "img/can-change.ceb043bf.svg";